import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-877dd77a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-topbar grid justify-content-center" }
const _hoisted_2 = {
  class: "flex h-full justify-content-between",
  style: {"width":"100%"}
}
const _hoisted_3 = { class: "flex align-items-center" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "pi pi-chevron-right m-3",
  style: {"font-size":"1rem"}
}
const _hoisted_6 = {
  key: 2,
  href: "/#/dashboard/dekaani-list"
}
const _hoisted_7 = { key: 3 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-chevron-right m-3",
  style: {"font-size":"1rem"}
}, null, -1))
const _hoisted_9 = { class: "align-self-center ml-auto" }
const _hoisted_10 = {
  key: 0,
  class: "p-link layout-topbar-menu-button layout-topbar-button circle ml-auto align-self-center mt-1"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-ellipsis-v" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "layout-topbar-menu hidden origin-top align-self-center"
}
const _hoisted_14 = {
  key: 0,
  class: "flex align-items-center"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ml-2 flex flex-column align-items-center",
  style: {"font-size":".95rem","font-weight":"500"}
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Developer mode"),
  /*#__PURE__*/_createElementVNode("span", null, "(panel system)")
], -1))
const _hoisted_16 = {
  class: "p-link layout-topbar-button",
  style: {"cursor":"default","pointer-events":"none"}
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user" }, null, -1))
const _hoisted_18 = { class: "limit-width" }
const _hoisted_19 = { class: "no-text" }
const _hoisted_20 = {
  key: 0,
  class: "pi pi-bell"
}
const _hoisted_21 = {
  key: 1,
  class: "pi pi-bell"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Notifications", -1))
const _hoisted_23 = { class: "no-text" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-sign-out" }, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Log out", -1))
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = { class: "flex flex-column" }
const _hoisted_28 = { class: "flex justify-content-between align-items-center mt-0" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Notifications", -1))
const _hoisted_30 = { class: "flex" }
const _hoisted_31 = { class: "flex flex-column ml-2" }
const _hoisted_32 = { class: "notification-title" }
const _hoisted_33 = { class: "notification-time" }
const _hoisted_34 = { class: "flex justify-content-end" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "m-3" }, "No notifications")
], -1))
const _hoisted_36 = {
  key: 1,
  class: "w-full flex align-items-center justify-content-center"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "m-0" }, "Notifications", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-bell mr-3" }, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "All notifications", -1))
const _hoisted_40 = { class: "flex flex-column ml-2" }
const _hoisted_41 = { class: "notification-title" }
const _hoisted_42 = { class: "notification-time" }
const _hoisted_43 = { class: "flex justify-content-end" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "m-3" }, "No notifications")
], -1))
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { class: "flex align-items-center mt-3" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mb-4" }, null, -1))
const _hoisted_48 = {
  key: 0,
  class: "flex justify-content-center"
}
const _hoisted_49 = ["innerHTML"]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-cog mr-3" }, null, -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Settings", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "p-2 pt-3 pb-0" }, "Available notifications", -1))
const _hoisted_53 = { style: {"font-weight":"500"} }
const _hoisted_54 = {
  class: "flex",
  style: {"white-space":"nowrap"}
}
const _hoisted_55 = { class: "field-checkbox mr-3" }
const _hoisted_56 = ["for"]
const _hoisted_57 = { class: "field-checkbox" }
const _hoisted_58 = ["for"]
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "m-3" }, "No notifications available")
], -1))
const _hoisted_60 = {
  key: 0,
  class: "flex w-full justify-content-center align-items-center"
}
const _hoisted_61 = {
  key: 1,
  class: "flex w-full justify-content-center align-items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_styleclass = _resolveDirective("styleclass")!
  const _directive_badge = _resolveDirective("badge")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, [
          (_ctx.$route.meta.parent)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$route.meta.parent), 1))
            : _createCommentVNode("", true),
          (_ctx.$route.meta.parent)
            ? (_openBlock(), _createElementBlock("i", _hoisted_5))
            : _createCommentVNode("", true),
          (_ctx.$route.params.id && _ctx.$route.name == 'dekaani-list')
            ? (_openBlock(), _createElementBlock("a", _hoisted_6, _toDisplayString(_ctx.$route.meta.title), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$route.meta.title), 1)),
          (_ctx.$route.params.id && _ctx.$route.name == 'dekaani-list')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _hoisted_8,
                _createElementVNode("span", null, "Task #" + _toDisplayString(_ctx.$route.params.id), 1)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          (_ctx.store.state.auth.loggedIn)
            ? _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_10, _hoisted_12)), [
                [_directive_styleclass, { selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true }]
              ])
            : _createCommentVNode("", true),
          (_ctx.store.state.auth.loggedIn)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
                (_ctx.$route.meta.devmode && _ctx.$store.state.auth.user.role.permissions.find(p => p == 'system.*'))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                      _createVNode(_component_InputSwitch, {
                        modelValue: _ctx.devmode,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.devmode) = $event)),
                        onChange: _ctx.toggleDevMode
                      }, null, 8, ["modelValue", "onChange"]),
                      _hoisted_15
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("li", null, [
                  _createElementVNode("button", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.store.state.auth.user.email), 1)
                  ])
                ]),
                _createElementVNode("li", _hoisted_19, [
                  _withDirectives((_openBlock(), _createElementBlock("button", {
                    class: "p-link layout-topbar-button circle",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleNotificationPanel && _ctx.toggleNotificationPanel(...args))),
                    "aria:haspopup": "true",
                    "aria-controls": "notification-panel"
                  }, [
                    (_ctx.$store.state.auth.user.count_unread_notifications > 0)
                      ? _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_20, null, 512)), [
                          [
                            _directive_badge,
                            _ctx.$store.state.auth.user.count_unread_notifications,
                            void 0,
                            { danger: true }
                          ]
                        ])
                      : (_openBlock(), _createElementBlock("i", _hoisted_21)),
                    _hoisted_22
                  ])), [
                    [
                      _directive_tooltip,
                      'Notifications',
                      void 0,
                      { left: true }
                    ]
                  ])
                ]),
                _createElementVNode("li", _hoisted_23, [
                  _withDirectives((_openBlock(), _createElementBlock("button", {
                    class: "p-link layout-topbar-button circle",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.logOut && _ctx.logOut(...args)))
                  }, _hoisted_26)), [
                    [
                      _directive_tooltip,
                      'Log out',
                      void 0,
                      { left: true }
                    ]
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_OverlayPanel, {
        ref: "np",
        appendTo: "body",
        id: "notification-panel",
        style: {"width":"450px"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("h6", _hoisted_28, [
              _hoisted_29,
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_Button, {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.getNotificationSettings();_ctx.notificationsTabIndex = 1;_ctx.modal.notifications = true;_ctx.np.hide();}),
                  icon: "pi pi-cog",
                  class: "p-button-rounded p-button-text p-button button-notification-settings p-2",
                  label: "Settings"
                })
              ])
            ]),
            ((_ctx.notifications && _ctx.notifications.data) || _ctx.loading.notifications)
              ? (_openBlock(), _createBlock(_component_DataTable, {
                  key: 0,
                  value: _ctx.notifications.data.slice(0, 5),
                  class: "p-datatable-sm",
                  responsiveLayout: "scroll",
                  style: {"margin-left":"-1.25rem","margin-right":"-1.25rem"},
                  rowHover: "",
                  rowClass: _ctx.rowClass,
                  onRowClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.getNotificationSettings();_ctx.notificationsTabIndex = 0;_ctx.np.hide();_ctx.showNotification(_ctx.getNotificationTypeInfo($event.data.notification).title, $event.data.notification.id)})
                }, {
                  empty: _withCtx(() => [
                    _hoisted_35
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      field: "name",
                      header: "Name"
                    }, {
                      body: _withCtx((slotProps) => [
                        _createElementVNode("span", _hoisted_31, [
                          _createElementVNode("span", _hoisted_32, _toDisplayString(slotProps.data.title), 1),
                          _createElementVNode("span", _hoisted_33, _toDisplayString((new Date(slotProps.data.notification.created_at)).toLocaleString('en-GB')), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "",
                      header: "",
                      style: {"text-align":"right","width":"0"}
                    }, {
                      body: _withCtx((slotProps) => [
                        _createElementVNode("div", _hoisted_34, [
                          _withDirectives(_createVNode(_component_Button, {
                            onClick: ($event: any) => {_ctx.markNotificationAsRead(slotProps.data.notification.id); _ctx.$router.push('/dashboard/' + slotProps.data.info.page + (slotProps.data.info.domicile ? '/' + slotProps.data.notification.data.domicile : '')); _ctx.np.toggle($event);},
                            icon: "pi pi-arrow-up-right",
                            class: "p-button-rounded p-button-text p-button button-clear-notification mr-1"
                          }, null, 8, ["onClick"]), [
                            [
                              _directive_tooltip,
                              slotProps.data.info.page_title,
                              void 0,
                              { left: true }
                            ]
                          ]),
                          (!slotProps.data.notification.read_at)
                            ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                                key: 0,
                                onClick: ($event: any) => (_ctx.markNotificationAsRead(slotProps.data.notification.id)),
                                icon: "pi pi-check-circle",
                                class: "p-button-rounded p-button-text p-button button-clear-notification mr-1"
                              }, null, 8, ["onClick"])), [
                                [
                                  _directive_tooltip,
                                  'Mark as read',
                                  void 0,
                                  { left: true }
                                ]
                              ])
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value", "rowClass"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _createVNode(_component_ProgressSpinner, {
                    style: {"width":"5rem","height":"5rem"},
                    class: "m-7",
                    animationDuration: "1.5s",
                    strokeWidth: "2px"
                  })
                ])),
            _createElementVNode("span", {
              class: "link text-center w-full button-all-notifications",
              onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.notificationsTabIndex = 0;_ctx.getNotificationSettings();_ctx.hideNotification();_ctx.modal.notifications = true;_ctx.np.hide()})
            }, "All notifications")
          ])
        ]),
        _: 1
      }, 512)
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.modal.notifications,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.modal.notifications) = $event)),
      closable: true,
      style: {maxWidth: '800px', width: '100vw'},
      draggable: false,
      modal: true,
      position: "center",
      onHide: _ctx.getNotifications
    }, {
      header: _withCtx(() => [
        _hoisted_37
      ]),
      footer: _withCtx(() => [
        (_ctx.notificationsTabIndex == 0 && _ctx.notificationData.id == null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
              _createVNode(_component_Button, {
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.markNotificationAsRead())),
                icon: "pi pi-check-circle",
                class: "p-button-rounded p-button-text p-button button-notification-settings",
                label: "Mark all as read"
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.notificationsTabIndex == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
              _createVNode(_component_Button, {
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.saveNotificationSettings())),
                icon: "pi pi-save",
                class: "p-button-rounded p-button-text p-button button-notification-settings",
                label: "Save settings"
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_TabView, {
          ref: "notification_tabs",
          class: "m-0 mt-0",
          activeIndex: _ctx.notificationsTabIndex,
          "onUpdate:activeIndex": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.notificationsTabIndex) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TabPanel, null, {
              header: _withCtx(() => [
                _hoisted_38,
                _hoisted_39,
                (_ctx.$store.state.auth.user.count_unread_notifications > 0)
                  ? (_openBlock(), _createBlock(_component_Tag, {
                      key: 0,
                      value: _ctx.$store.state.auth.user.count_unread_notifications,
                      severity: "danger",
                      rounded: "",
                      style: {"max-height":"1.25rem","min-width":"1.25rem"},
                      class: "ml-2"
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                (_ctx.notificationData.id == null && ((_ctx.notifications && _ctx.notifications.data) || _ctx.loading.notifications))
                  ? (_openBlock(), _createBlock(_component_DataTable, {
                      key: 0,
                      value: _ctx.notifications.data,
                      class: "p-datatable-sm",
                      responsiveLayout: "scroll",
                      rowHover: "",
                      paginator: true,
                      rows: _ctx.notifications.per_page,
                      totalRecords: _ctx.notifications.total,
                      onPage: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getNotifications($event.page + 1))),
                      lazy: true,
                      rowClass: _ctx.rowClass,
                      onRowClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showNotification(_ctx.getNotificationTypeInfo($event.data.notification).title, $event.data.notification.id)))
                    }, {
                      empty: _withCtx(() => [
                        _hoisted_44
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_Column, {
                          field: "name",
                          header: "Name"
                        }, {
                          body: _withCtx((slotProps) => [
                            _createElementVNode("span", _hoisted_40, [
                              _createElementVNode("span", _hoisted_41, _toDisplayString(slotProps.data.title), 1),
                              _createElementVNode("span", _hoisted_42, _toDisplayString((new Date(slotProps.data.notification.created_at)).toLocaleString('en-GB')), 1)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "",
                          header: "",
                          style: {"text-align":"right","width":"0"}
                        }, {
                          body: _withCtx((slotProps) => [
                            _createElementVNode("div", _hoisted_43, [
                              _withDirectives(_createVNode(_component_Button, {
                                onClick: ($event: any) => {_ctx.markNotificationAsRead(slotProps.data.notification.id); _ctx.$router.push('/dashboard/' + slotProps.data.info.page + (slotProps.data.info.domicile ? '/' + slotProps.data.notification.data.domicile : '')); _ctx.modal.notifications = false},
                                icon: "pi pi-arrow-up-right",
                                class: "p-button-rounded p-button-text p-button button-clear-notification mr-1"
                              }, null, 8, ["onClick"]), [
                                [
                                  _directive_tooltip,
                                  slotProps.data.info.page_title,
                                  void 0,
                                  { left: true }
                                ]
                              ]),
                              (!slotProps.data.notification.read_at)
                                ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                                    key: 0,
                                    onClick: ($event: any) => (_ctx.markNotificationAsRead(slotProps.data.notification.id)),
                                    icon: "pi pi-check-circle",
                                    class: "p-button-rounded p-button-text p-button button-clear-notification mr-1"
                                  }, null, 8, ["onClick"])), [
                                    [
                                      _directive_tooltip,
                                      'Mark as read',
                                      void 0,
                                      { left: true }
                                    ]
                                  ])
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value", "rows", "totalRecords", "rowClass"]))
                  : _createCommentVNode("", true),
                (_ctx.notificationData.id != null && !_ctx.loading.notification)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                      _createElementVNode("h6", _hoisted_46, [
                        _createVNode(_component_Button, {
                          icon: "pi pi-chevron-left",
                          class: "p-button-rounded p-button-text mr-2",
                          onClick: _ctx.hideNotification
                        }, null, 8, ["onClick"]),
                        _createElementVNode("span", null, _toDisplayString(_ctx.notificationData.title), 1)
                      ]),
                      _hoisted_47,
                      (_ctx.loading.notification)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                            _createVNode(_component_ProgressSpinner, {
                              style: {"width":"5rem","height":"5rem"},
                              class: "m-7",
                              animationDuration: "1.5s",
                              strokeWidth: "2px"
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.notificationData.html != null)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            innerHTML: _ctx.notificationData.html
                          }, null, 8, _hoisted_49))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_TabPanel, null, {
              header: _withCtx(() => [
                _hoisted_50,
                _hoisted_51
              ]),
              default: _withCtx(() => [
                _hoisted_52,
                _createVNode(_component_DataTable, {
                  value: _ctx.notificationSettings,
                  class: "p-datatable-sm",
                  lazy: true
                }, {
                  empty: _withCtx(() => [
                    _hoisted_59
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      field: "name",
                      header: "Notification"
                    }, {
                      body: _withCtx((slotProps) => [
                        _createElementVNode("span", _hoisted_53, _toDisplayString(slotProps.data.info.title), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "description",
                      header: "Description"
                    }, {
                      body: _withCtx((slotProps) => [
                        _createTextVNode(_toDisplayString(slotProps.data.info.description), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "enabled",
                      header: "Enabled"
                    }, {
                      body: _withCtx((slotProps) => [
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("div", _hoisted_55, [
                            _createVNode(_component_Checkbox, {
                              id: 'enabled' + '-' + slotProps.data.info.name,
                              name: 'enabled' + '-' + slotProps.data.info.name,
                              modelValue: slotProps.data.notification.setting.enabled,
                              "onUpdate:modelValue": ($event: any) => ((slotProps.data.notification.setting.enabled) = $event),
                              binary: true
                            }, null, 8, ["id", "name", "modelValue", "onUpdate:modelValue"]),
                            _createElementVNode("label", {
                              for: 'enabled' + '-' + slotProps.data.info.name
                            }, "Enabled", 8, _hoisted_56)
                          ]),
                          _createElementVNode("div", _hoisted_57, [
                            _createVNode(_component_Checkbox, {
                              disabled: !slotProps.data.notification.setting.enabled,
                              id: 'mail' + '-' + slotProps.data.info.name,
                              name: 'mail' + '-' + slotProps.data.info.name,
                              modelValue: slotProps.data.notification.setting.mail,
                              "onUpdate:modelValue": ($event: any) => ((slotProps.data.notification.setting.mail) = $event),
                              binary: true
                            }, null, 8, ["disabled", "id", "name", "modelValue", "onUpdate:modelValue"]),
                            _createElementVNode("label", {
                              for: 'mail' + '-' + slotProps.data.info.name
                            }, "Receive email", 8, _hoisted_58)
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["activeIndex"])
      ]),
      _: 1
    }, 8, ["visible", "onHide"])
  ], 64))
}